import {lazyInitialize, nonenumerable} from 'core-decorators';
import APIRequestState from './_util/api-request';

class AddSearchAttemptState extends APIRequestState {
  putRequest(queryParams, ...params) {
    return this.ctx.sdk.post(`/search-attempts?${queryParams}`, ...params);
  }
}

class SearchAttemptsState {
  @lazyInitialize @nonenumerable addSearchAttempt = new AddSearchAttemptState(this.ctx);

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default SearchAttemptsState;



// WEBPACK FOOTER //
// ./spa/state/search-attempts.jsx